import { GLOBAL_DICTIONARY } from '../constants/global-dictionary.constant';

export const claimResponse = (selectValue, textAreaValue) => (selectValue === GLOBAL_DICTIONARY.other ? textAreaValue : selectValue);
